// extracted by mini-css-extract-plugin
export var dividerLine = "_6m-3";
export var itemImage = "_6m-9";
export var lightDivider = "_6m-4";
export var modalContent = "_6m-5";
export var modalContentCompact = "_6m-6";
export var productCard = "_6m-a";
export var productImage = "_6m-b";
export var productImageCompact = "_6m-7";
export var productImagePlaceholder = "_6m-c";
export var productImagePlaceholderCompact = "_6m-8";
export var progressBarBackground = "_6m-1";
export var progressBarContainer = "_6m-0";
export var progressBarFill = "_6m-2";